import { render, staticRenderFns } from "./CommentFeedBasic.vue?vue&type=template&id=676efc06&scoped=true&"
import script from "./CommentFeedBasic.vue?vue&type=script&lang=ts&"
export * from "./CommentFeedBasic.vue?vue&type=script&lang=ts&"
import style0 from "./CommentFeedBasic.vue?vue&type=style&index=0&id=676efc06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676efc06",
  null
  
)

export default component.exports